module.exports = __webpack_public_path__ + "static/media/peaks.59fff1e2.svg";